<p class="card-text">
    Her kan du laste ned dokumenter knyttet til saken.
</p>

<table mat-table matSort class="incidents" [dataSource]="dataSource">

    <ng-container matColumnDef="Select">
        <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="{'collapsed-cell': !isGroup(i, element) && !documentGroupIsOpen(element)}">
            <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggleRow(element)"
                [checked]="selection.isSelected(element)">
            </mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="DocumentDate">
        <th mat-header-cell *matHeaderCellDef>Dato</th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="{'collapsed-cell': !isGroup(i, element) && !documentGroupIsOpen(element)}">
            <div class="column-wrapper" [@detailExpand]="documentGroupIsOpen(element) ? 'expanded' : 'collapsed'">
                <span class="column-data">
                    {{element.Created | date: 'dd.MM.yyyy'}}
                </span>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="UploadedBy">
        <th mat-header-cell *matHeaderCellDef>Avsender</th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="{'collapsed-cell': !isGroup(i, element) && !documentGroupIsOpen(element)}">
            <div class="column-wrapper" [@detailExpand]="documentGroupIsOpen(element) ? 'expanded' : 'collapsed'">
                <span class="column-data">
                    {{element.UploadedBy}}
                </span>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="FileName">
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="{'collapsed-cell': !isGroup(i, element) && !documentGroupIsOpen(element)}">
            <div class="column-wrapper" [@detailExpand]="documentGroupIsOpen(element) ? 'expanded' : 'collapsed'">
                <div class="column-wrapper"
                    [ngClass]="{'regular-file': !isGroup(i, element), 'main-letter' : isGroup(i, element)}">
                    <span (click)="openDocument(element)" class="column-data link click">
                        {{element.FileName}}
                    </span>
                    <span *ngIf="isGroup(i, element) && groupHasChildren(element)"
                        (click)="toggleDocumentGroupOpenStatus(element)" matTooltipPosition="right"
                        [matTooltip]="documentGroupIsOpen(element) ? 'Skjul vedlegg' : 'Vis vedlegg'" class="click">
                        <mat-icon *ngIf="!documentGroupIsOpen(element)">expand_more</mat-icon>
                        <mat-icon *ngIf="documentGroupIsOpen(element)">expand_less</mat-icon>
                    </span>
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="Size">
        <th mat-header-cell *matHeaderCellDef>Størrelse</th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="{'collapsed-cell': !isGroup(i, element) && !documentGroupIsOpen(element)}">
            <div class="column-wrapper" [@detailExpand]="documentGroupIsOpen(element) ? 'expanded' : 'collapsed'">
                <span>{{formatBytes(element.FileSize, 2)}}</span>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let rowData; columns: displayedColumns; when: isGroup"></tr>
    <tr class="document-group-row" mat-row *matRowDef="let rowData; columns: displayedColumns; when: !isGroup"></tr>

</table>

<div style="margin: 1em">
    <button style="flex:0 1 150px" (click)="downloadSelectedDocuments()" class="finkn-btn" mat-raised-button color="primary" role="button"
        *ngIf="this.selection.selected.length > 0">
        <mat-icon>download</mat-icon>
        Last ned {{this.selection.selected.length}} dokument<span *ngIf="this.selection.selected.length !== 1">er</span>
    </button>
</div>
